export default __webpack_public_path__ + "static/media/DNo.2-3.2f616d91.jpg";